// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-blend-in{color:#c9ccde}.disabled{opacity:.5;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
